export default __webpack_public_path__ + "static/media/Whispering Touch.22e827c1.jpg";